import { DragDropContext, Draggable, Droppable, DropResult } from "react-beautiful-dnd";
import MultipleSelect from "../../../../../../common-components/multipleSelect";
import { IMainTasksDetails } from "../../../../../../models/freshman/configuration";
import FreshmanConfigurationSubTask from "./freshmanConfigurationSubTask";
import { useEffect, useState } from "react";
import { IDropdownData } from "../../../../../../models/ICommon";
import MultipleInactiveSelect from "../../../../../../common-components/multipleInactiveSelect";

const FreshmanConfigurationMainTask = (props: IMainTasksDetails) => {
  const {
    mainTaskData,
    selectedMainStep,
    setSubTaskData,
    subTaskData,
    subSteps,
    setMainTaskData,
    mainSteps,
    errors,
    handleMainStep,
    allSubSteps
  } = props;

  const [mainStepsData, setMainStepsData] = useState<IDropdownData[]>([])

  useEffect(() => {
    const activeDropdownData: IDropdownData[] = mainSteps
      .filter((data) => data.isActive === true)
      .map((data) => ({
        id: data.id,
        name: data.name,
        isActive: data.isActive
      }));
    const inactiveDropdownData: IDropdownData[] = mainTaskData.mainTask
      .map((data) => ({
        id: data.id,
        name: data.name,
        isActive: mainSteps.find((mainStep) => mainStep.id == data.id)?.isActive
      }));
    const uniqueSteps = new Map(
      [...activeDropdownData, ...inactiveDropdownData].map(item => [item.id, item])
    );

    setMainStepsData(Array.from(uniqueSteps.values()));
    
  }, [mainSteps, mainTaskData]);

  const onMainChange = (event: any) => {
    if (event.target.name === "mainSteps") {
      const _mainTasks = Array.from(event.target.value);
      let updatedMainStep = _mainTasks.map((mt: any, index: number) => ({
        id: mt,
        order: index + 1,
        prerequisites: [],
        subSteps: [],
        name: mainSteps.find((ms) => ms.id == mt)?.name,
      }));
      setMainTaskData({ ...mainTaskData, mainTask: updatedMainStep });
    } else if (event.target.name === "mainStepPredecessor") {
      const stepIndex = mainTaskData.mainTask?.findIndex(
        (mt) => mt.id === selectedMainStep
      );
      let task = mainTaskData.mainTask;

      task[stepIndex] = {
        ...task[stepIndex],
        prerequisites: event.target.value,
      };

      setMainTaskData({ ...mainTaskData, mainTask: task });
    }
  };

  const handleOnDragEndMain = async (result: DropResult) => {
    const { destination, source } = result;
    if (!destination) return;

    const _tasks = mainTaskData.mainTask;
    const [movedItem] = _tasks.splice(source.index, 1);
    _tasks.splice(destination.index, 0, movedItem);

    const updatedOrder = _tasks.map((step, index) => ({
      ...step,
      order: index + 1,
      name: step.name,
      subSteps: step.subSteps,
      prerequisites: [],
    }));
    setMainTaskData({ ...mainTaskData, mainTask: updatedOrder });
  };

  const removeMainTask = (mainStepId: number) => {
    const currentOrder =
      mainTaskData.mainTask?.find((ms) => ms.id == mainStepId)?.order ??
      Infinity;
    const updatedMainTasks = mainTaskData.mainTask
      ?.filter((ms) => ms.id !== mainStepId)
      ?.map((task) => {
        return {
          ...task,
          order:
            (task?.order ?? 0) < currentOrder
              ? task?.order
              : (task?.order ?? Infinity) - 1,
          prerequisites: task?.prerequisites?.filter(
            (pre) => pre !== mainStepId
          ),
        };
      });
    setMainTaskData({ ...mainTaskData, mainTask: updatedMainTasks });
    const updatedSubTasks = subTaskData.subTask?.filter(
      (ss) => ss.mainStepId !== mainStepId
    );
    setSubTaskData({ ...subTaskData, subTask: updatedSubTasks });
  };

  return (
    <>
      <div className="leftwrap maintask-content">
        <div className="titlewrap">
          <h6>Main Task List</h6>
          <div className="w-multiselect dd-freshman-config">
            <MultipleInactiveSelect
              label={""}
              onChange={onMainChange}
              isMandatory={false}
              values={
                mainTaskData.mainTask
                  ?.map((ms) => ms.id)
                  ?.filter((id): id is number => id !== null) || []
              }
              name={"mainSteps"}
              optionList={mainStepsData}
              placeholder={"Select Main Tasks"}
            />
            {errors?.mainSteps && (
              <div className="text-danger">{errors.mainSteps}</div>
            )}
          </div>
        </div>

        <div>
          <DragDropContext onDragEnd={handleOnDragEndMain}>
            <Droppable droppableId="stepId">
              {(provided) => (
                <ul ref={provided.innerRef} {...provided.droppableProps}>
                  {mainTaskData.mainTask?.map((step, index) => (
                    <Draggable
                      key={step.id}
                      draggableId={step.id?.toString() || index.toString()}
                      index={index}
                    >
                      {(provided) => (
                        <li
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          onClick={() => handleMainStep(step.id || 0)}
                          className={
                            step.id === selectedMainStep ? "active" : ""
                          }
                        >
                          <div className="numbered">
                            <img src="/assets/images/drag.svg" alt="" />
                          </div>
                          <div className="title">
                            <p>{step.name}</p>
                            <div className="form-group w-100 mt-2">
                              {step.order && step.order > 1 && (
                                <MultipleSelect
                                  label={""}
                                  onChange={onMainChange}
                                  isMandatory={false}
                                  values={
                                    mainTaskData.mainTask?.find(
                                      (mt) => mt.id == step.id
                                    )?.prerequisites || []
                                  }
                                  name={"mainStepPredecessor"}
                                  optionList={mainTaskData.mainTask.filter(
                                    (mt) => {
                                      const mtOrder = mt.order ?? Infinity;
                                      const stepOrder = step.order ?? Infinity;
                                      return mtOrder < stepOrder;
                                    }
                                  )}
                                  placeholder={"Select Predecessor"}
                                />
                              )}
                            </div>
                          </div>
                          <div className="form-checkbox">
                            <button
                              className="btn-close"
                              onClick={() => removeMainTask(step.id ?? 0)}
                            ></button>
                          </div>
                        </li>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </ul>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
      <FreshmanConfigurationSubTask
        subTaskData={subTaskData}
        setSubTaskData={setSubTaskData}
        selectedMainStep={selectedMainStep}
        mainTaskData={mainTaskData}
        subSteps={subSteps}
        allSubSteps={allSubSteps}
      />
    </>
  );
};

export default FreshmanConfigurationMainTask;
